<template>
  <div>
    <div v-if="currentErrors" class="text-danger">
      <div v-for="err in currentErrors">{{err}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errors: [],
    index: 0,
    name: null,
  },
  computed: {
    currentErrors() {
      return this.errors[this.index] && this.errors[this.index][this.name];
    }
  }
}
</script>